import { Link } from "gatsby";
import { useState } from "react";
import toggle from "./toggle";
import MenuItem from "./menu-item";

function AcademicsMenu(props) {
  const [isAcademicsMenu, toggleAcademicsMenu] = useState(false);
  const toggleFunction = () => {
    toggle(toggleAcademicsMenu, !isAcademicsMenu);
  };

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${
        props.cssClass || ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <ul className="flex flex-wrap -mx-2">
          <li className="w-full md:w-4/12 px-2">
            <ul>
              <li className="py-2">
                <MenuItem
                  linkKey={"Overview"}
                  linkUrl={"/academics"}
                  linkText={"Explore Academics"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Go behind the scenes of Rollins’ future-proof brand of liberal arts education."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Majors and Minors"}
                  linkUrl={"/academics/majors-minors"}
                  linkText={"Majors, Minors, and Special Programs"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Rollins offers more than 60 paths to a transformative education. Explore them all."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Rollins Foundations in the Liberal Arts"}
                  linkUrl={"/academics/rollins-foundations-in-the-liberal-arts"}
                  linkText={"Rollins Foundations in the Liberal Arts"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "These aren’t your average gen eds. See how our one-of-a-kind curriculum is different."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Rollins College Conference"}
                  linkUrl={"/academics/rollins-college-conference"}
                  linkText={"Rollins College Conference"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Your first year of college can be daunting. Find out how we ease the transition."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-4">
            {/* <h2 className='text-gray-300 uppercase font-bold tracking-wide text-xs'>The Rollins Experience</h2> */}
            <ul className="">
              <li className="py-2">
                <MenuItem
                  linkKey={"Personalized Learning Environment"}
                  linkUrl={"/academics/personalized-learning-environment"}
                  linkText={"Personalized Learning Environment"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Our individualized approach gives you the support you need to succeed."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Cool College Classes"}
                  linkUrl={"/academics/cool-college-classes"}
                  linkText={"Cool Classes"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "What’s a Rollins classroom like? Find out by exploring some of our can’t-miss courses."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Faculty"}
                  linkUrl={"/academics/faculty"}
                  linkText={"Great Guides"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Our expert faculty are true partners dedicated to helping you unlock your unique potential."
                  }
                />
              </li>
              <li className="py-2">
                <MenuItem
                  linkKey={"Study Abroad"}
                  linkUrl={"/academics/study-abroad"}
                  linkText={"Study Abroad"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "With 90+ programs to choose from, get ready to explore the globe."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-4/12 px-4 md:pr-6">
            <h2 className="text-gray-500 uppercase font-bold tracking-wide text-xs mt-2 mb-1">
              Prestigious Programs
            </h2>
            <p className="text-xs leading-tight text-gray-600">
              Rollins offers an array of programs designed with academically
              gifted students in mind. Check out our options for taking your
              college experience to the next level.
            </p>
            <ul className="mt-2">
              <li className="py-2">
                <a
                  className="tracking-tight leading-tight block font-bold text-sm text-blue-500 hover:underline"
                  key="Grand Challenges Scholars Program"
                  href="/academics/grand-challenges-scholars-program"
                  onClick={() => {
                    toggle(toggleAcademicsMenu, !isAcademicsMenu);
                  }}
                >
                  Grand Challenges Scholars Program
                </a>
              </li>
              <li className="py-2">
                <a
                  className="tracking-tight leading-tight block font-bold text-sm text-blue-500 hover:underline"
                  key="Honors Program"
                  href="/academics/honors-program"
                  onClick={() => {
                    toggle(toggleAcademicsMenu, !isAcademicsMenu);
                  }}
                >
                  Honors Program
                </a>
              </li>
              <li className="py-2">
                <a
                  className="tracking-tight leading-tight block font-bold text-sm text-blue-500 hover:underline"
                  key="Phi Beta Kappa"
                  href="/phi-beta-kappa"
                  onClick={() => {
                    toggle(toggleAcademicsMenu, !isAcademicsMenu);
                  }}
                >
                  Phi Beta Kappa
                </a>
              </li>
              <li className="py-2">
                <a
                  className="tracking-tight leading-tight block font-bold text-sm text-blue-500 hover:underline"
                  key="Student-Faculty Collaborative Scholarship Program"
                  href="/academics/collaborative-research"
                  onClick={() => {
                    toggle(toggleAcademicsMenu, !isAcademicsMenu);
                  }}
                >
                  Student-Faculty Collaborative Scholarship Program
                </a>
              </li>
              <li className="py-2">
                <a
                  className="tracking-tight leading-tight block font-bold text-sm text-blue-500 hover:underline"
                  key="Women in Finance"
                  href="/academics/women-in-finance"
                  onClick={() => {
                    toggle(toggleAcademicsMenu, !isAcademicsMenu);
                  }}
                >
                  Women in Finance Program
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AcademicsMenu;
